export default "__VITE_ASSET__BLkn09fK__";